// LomavisTabSwitcherCard1.tsx
import React from 'react';
import { Stack } from 'react-bootstrap';
import { translateComponent } from '@/utils/tolgee/translateComponent';

export type LomavisTabItem = {
  key: string;
  label: string;
  count?: number;
  disabled?: boolean;
};

interface LomavisTabSwitcherCard1Props {
  tabs: LomavisTabItem[];
  activeKey: string;
  onChange: (key: string) => void;
  className?: string;
  accentColor?: string; // purple
  underlineWidth?: number; // px, default 48
}

export const LomavisTabSwitcherCard1: React.FC<
  LomavisTabSwitcherCard1Props
> = ({
  tabs,
  activeKey,
  onChange,
  className,
  accentColor,
  underlineWidth = 48
}) => {
  const t = translateComponent('LomavisTabSwitcherCard1');
  const purple = accentColor ?? 'var(--bs-primary)';

  return (
    <Stack
      role="tablist"
      aria-label={t('Tabs')}
      direction="horizontal"
      gap={4}
      className={`w-100 border-bottom ${className ?? ''}`}
      style={{ background: '#fff' }}
    >
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        const isDisabled = !!tab.disabled;

        return (
          <button
            key={tab.key}
            role="tab"
            aria-selected={isActive}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            onClick={() => !isDisabled && onChange(tab.key)}
            className={`bg-transparent border-0 px-0 ${
              isActive ? 'text-black fw-bolder' : 'text-muted fw-semibold'
            }`}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            {/* Make the button a vertical flex so underline sits directly under the label */}
            <div className="d-flex flex-column align-items-center pt-3  px-3 gap-1 fs-6">
              <span className="d-inline-flex align-items-center gap-1">
                <span>{t(tab.label)}</span>
                {typeof tab.count === 'number' && tab.count > 0 && (
                  <span style={{ color: purple, fontWeight: 600 }}>
                    +{tab.count}
                  </span>
                )}
              </span>

              {/* Underline sits inside layout, centered, no absolute math */}
              {isActive ? (
                <span
                  aria-hidden
                  className="w-100"
                  style={{
                    height: 4,
                    borderRadius: 999,
                    background: purple,
                    marginBottom: -2 // tuck slightly into the bottom border line
                  }}
                />
              ) : (
                // keep height to avoid layout shift if you want; or return null
                <span
                  style={{
                    height: 4,

                    opacity: 0,
                    marginBottom: -2
                  }}
                />
              )}
            </div>
          </button>
        );
      })}
    </Stack>
  );
};
